/**
 * Contact Popup Component
 * Zeigt einen Kontakt-Popup nach konfigurierbarer Wartezeit an
 * mit Reopen-Button und Mobile-Detection
 */

// Konfiguration - hier kannst du die Zeit anpassen
const CONFIG = {
	delayTime: 10000, // 25 Sekunden (in Millisekunden)
	mobileBreakpoint: 768, // Pixel-Breite für Mobile Detection
};

export function initContactPopup() {
	// 1. DOM-Elemente selektieren
	const popup = document.querySelector(".contact-popup");
	const closeButton = document.querySelector(".contact-popup .close-button");
	const reopenButton = document.querySelector(".reopen-button");

	// 2. Early Return wenn Elemente nicht existieren
	if (!popup || !reopenButton) {
		return;
	}

	// 3. Initial Display Funktion
	function delayedDisplay() {
		const isMobile = window.innerWidth <= CONFIG.mobileBreakpoint;

		setTimeout(() => {
			if (isMobile) {
				// Mobile: nur Reopen-Button anzeigen
				showReopenButton(reopenButton);
			} else {
				// Desktop: Popup anzeigen
				showPopup(popup);
			}
		}, CONFIG.delayTime);
	}

	// 4. Initial Display starten
	delayedDisplay();

	// 5. Close Button Event Listener
	if (closeButton) {
		closeButton.addEventListener("click", () => {
			closePopup(popup, reopenButton);
		});
	}

	// 6. Reopen Button Event Listener
	reopenButton.addEventListener("click", () => {
		openPopup(popup, reopenButton);
	});

	// 7. Escape Key zum Schließen
	document.addEventListener("keydown", (event) => {
		if (event.key === "Escape" && isPopupVisible(popup)) {
			closePopup(popup, reopenButton);
		}
	});
}

// Helper Funktionen (private, kein export)
function showPopup(popup) {
	popup.style.display = "block";
	setTimeout(() => {
		popup.style.opacity = "1";
		popup.style.visibility = "visible";
	}, 10);
}

function hidePopup(popup) {
	popup.style.opacity = "0";
	popup.style.visibility = "hidden";
	setTimeout(() => {
		popup.style.display = "none";
	}, 100);
}

function showReopenButton(button) {
	button.style.display = "flex";
	setTimeout(() => {
		button.style.opacity = "1";
		button.style.visibility = "visible";
	}, 10);
}

function hideReopenButton(button) {
	button.style.opacity = "0";
	button.style.visibility = "hidden";
	setTimeout(() => {
		button.style.display = "none";
	}, 100);
}

function closePopup(popup, reopenButton) {
	hidePopup(popup);
	setTimeout(() => {
		showReopenButton(reopenButton);
	}, 100);
}

function openPopup(popup, reopenButton) {
	hideReopenButton(reopenButton);
	setTimeout(() => {
		showPopup(popup);
	}, 100);
}

function isPopupVisible(popup) {
	return popup.style.opacity === "1" && popup.style.visibility === "visible";
}
